<script setup>
import { ref } from 'vue'
import { useSortable } from '@dnd-kit/vue/sortable'
import { CircleClose } from '@element-plus/icons-vue'

const props = defineProps({
  rookie: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  group: {
    type: String,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
})

defineEmits(['remove'])

const element = ref(null)
const handle = ref(null)

const { isDragging, isDropTarget } = useSortable({
  id: () => props.rookie.id,
  index: () => props.index,
  group: () => props.group,
  element,
  handle,
  transition: null,
})
</script>

<template>
  <div
    ref="element"
    class="rookie-drag-item"
    :class="{
      'is-dragging': isDragging,
      'is-drop-target': isDropTarget,
    }"
  >
    <div ref="handle" class="handle">
      <el-image
        lazy
        style="width: 160px"
        :src="`${cdnUrl}/${rookie.thumbnail}`"
      />
    </div>
    <el-tag
      v-if="rookie.animation"
      type="success"
      style="position: absolute; top: 5px; left: 5px"
    >
      动图
    </el-tag>
    <span style="word-break: break-word; display: block">{{ rookie.image_id }}</span>
    <el-icon
      style="position: absolute; top: 5px; right: 5px; cursor: pointer"
      @click.stop="$emit('remove', rookie)"
    >
      <CircleClose />
    </el-icon>
  </div>
</template>

<style scoped>
.rookie-drag-item {
  position: relative;
  width: 160px;
  margin: 5px;
}

.rookie-drag-item.is-dragging {
  opacity: 0.35;
}

.rookie-drag-item.is-drop-target::before {
  content: '';
  position: absolute;
  left: -3px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--el-color-primary);
  pointer-events: none;
  z-index: 10;
  border-radius: 1px;
}

.handle {
  cursor: grab;
}

.handle:active {
  cursor: grabbing;
}
</style>
